<template>
  <b-container v-if="verified">
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            OCR Plat
          </h1>
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
          </h4>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <div class="col-12">
            <label class="textarea-input">Input Image:</label>
            <input ref="fileupload" class="mb-2 sm-input" type="file" accept="image/png, image/jpeg" @change="onChooseImage">
          </div>
          <div class="col-12">
            <b-form inline class="form-options mb-1">
              <label for="kad-type" class="mr-2">Detect Count: </label>
              <b-form-select v-model="nDetect">
                <b-form-select-option value="" selected>Not Set</b-form-select-option>
                <b-form-select-option value="1">1</b-form-select-option>
                <b-form-select-option value="2">2</b-form-select-option>
                <b-form-select-option value="3">3</b-form-select-option>
                <b-form-select-option value="4">4</b-form-select-option>
                <b-form-select-option value="5">5</b-form-select-option>
                <b-form-select-option value="6">6</b-form-select-option>
                <b-form-select-option value="7">7</b-form-select-option>
                <b-form-select-option value="8">8</b-form-select-option>
                <b-form-select-option value="9">9</b-form-select-option>
                <b-form-select-option value="10">10</b-form-select-option>
              </b-form-select>
            </b-form>
            <b-form inline class="form-options mb-4">
              <label for="kad-face" class="mr-2">Sort By: </label>
              <b-form-select v-model="sortBy">
                <b-form-select-option value="" selected>Not Set</b-form-select-option>
                <b-form-select-option value="ratio">By Ratio</b-form-select-option>
                <b-form-select-option value="size">By Size</b-form-select-option>
                <b-form-select-option value="distance">By Distance</b-form-select-option>
              </b-form-select>
            </b-form>
          </div>
          <div class="form-button col-12" style="display: flex">
            <div class="sm-nav-wrapper" style="margin-left: auto">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit" class="btn">
                  <span><img src=""></span>Submit
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-12">
            <label v-if="showPreview" class="textarea-input">Preview Image:</label>
            <b-img v-if="showPreview" :src="imagePreview" class="preview-image mb-2"></b-img>
          </div>
        </CRow>
      </div>
      <CRow v-if="results.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            RESPONSE DATA
          </h4>
        </CCol>
      </CRow>
      <div v-if="fileResult.length > 0" class="d-flex flex-column align-items-center mb-4">
        <b-img :src=fileResult class="preview-image-response"></b-img>
        <small>Number of vehicles detected: {{ nVehicles }} vehicle(s)</small>
      </div>
      <div v-if="results.length > 0" class="content">
        <CRow>
          <div class="col-12">
            <b-tabs content-class="mt-3" class="comparison-tabs" nav-class="comparison-tabs-list content-compact">
              <b-tab v-for="(items, index) in results" :key="`tab-results-${index}`" :title="`Result ${index+1}`" title-link-class="comparison-tab-header">
                <b-table small
                  :fields="fields"
                  :items="items"
                >
                  <template #cell(index)="row">
                    {{ row.index + 1 }}
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
          </div>
        </CRow>
      </div>
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
// import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      verified: false,
      isLoading: false,
      showErrorModal: false,
      // showOfficeModal: false,
      // showDaytimeModal: false,
      // showClocktimeModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      inputText: "",
      fields: [
          { key: 'index', label: 'No.' },
          { key: 'label', label: 'Label' },
          { key: 'value', label: 'Value' },
      ],
      keywords: [],
      fileResult: "",
      categoryMap: [],
      imagePreview: null,
      showPreview: false,
      base64: "",
      file: null,
      nDetect: "",
      sortBy: "",
      nVehicles: "",
      results: [],
      // serviceId: "",
      // serviceName: "",
      // customerId: "",
      // contractNo: "",
      // servOfficeCode: "",
      // workDayBook: 1,
      // officeOptions: [],
      // daytimeOptions: [],
      // clocktimeOptions: [],
      // selectedOffice: {},
      // selectedDaytime: {},
      // selectedClocktime: {}

      sample_response: {"success":true,"message":"STNK berhasil di proses","data":{"nomor_registrasi":{"value":"E 3472 WAB ","confidence":0.9866666666666667},"nama_pemilik":{"value":"BOBI AULIA SYAFIQ ","confidence":0.9966666666666667},"alamat":{"value":"KARANGTENGAH CLUSTER FRAMUKA CIANJUR REGENCY BLOKEDS NUMBERO- ","confidence":0.9714285714285715},"merk":{"value":"HONDA ","confidence":1},"type":{"value":"X1H02N35M1 A/T ","confidence":0.995},"jenis":{"value":"SEPEDA MOTOR ","confidence":1},"model":{"value":"SEPEDA MOTOR ","confidence":1},"tahun_pembuatan":{"value":"2019","confidence":1},"isi_silinder":{"value":"149 CC ","confidence":0.895},"nomor_rangka":{"value":"MH1KF4115KK705996","confidence":0.995},"nomor_mesin":{"value":"KF41E1708686","confidence":1},"warna":{"value":"HITAM ","confidence":1},"bahan_bakar":{"value":"BENSIN","confidence":1},"warna_tnkb":{"value":"HITAM","confidence":1},"tahun_registrasi":{"value":"2019","confidence":1},"nomor_bpkb":{"value":"P07918292","confidence":0.98},"kode_lokasi":{"value":"10700","confidence":1},"berlaku_sampai":{"value":"06 Nov 2024 ","confidence":1}},"image_path":"./output\\bobi_aulia_syafiq_9_jpg_combine.jpg","url":"http://10.10.131.108:8000/download_file/bobi_aulia_syafiq_9_jpg_combine.jpg"}
    }
  },
  methods: {
    onClickSubmitTest(){
      let raw = this.sample_response
      console.log(raw)
      let entries = []
      for (const [key, value] of Object.entries(raw.data)){
        let result = "Good"
        if(value.confidence < 0.9){
          result = "Bad"
        }
        entries.push({label: key, value: value.value, confidence: {"badge": result, "percentage": (value.confidence * 100).toFixed(2)}})
      }
      this.keywords = entries
      this.fileResult = raw.url
    },
    onChooseImage(e){
      this.keywords = []
      this.fileResult = []
      var file = e.target.files[0]
      if(file){
        this.file = e.target.files[0]
        this.imagePreview = URL.createObjectURL(file)
        // this.createBase64Image(file)
        this.showPreview = true
      }
    },
    createBase64Image(FileObject) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.base64 = reader.result.split(",")[1];
      }
      reader.readAsDataURL(FileObject);
    },
    onClickSubmit(){
      if(!this.file){
        this.errorLabel = "Mohon upload gambar Plat."
        this.errorReload = false
        this.showErrorModal = true
        return
      }
      this.isLoading = true
      // let processUrl = "https://ktp.ocr.dev.inergi.id/api-plat/detect_image"
      let processUrl = "https://validation.demo.inergi.id/api/api-plat/detect_image"
      let data = new FormData()
      data.set('image', this.file)
      if(this.nDetect) data.set('n_detect', this.nDetect)
      if(this.sortBy) data.set('sort_by', this.sortBy)
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          let raw = response.data
          if(raw.success) {
            this.results = []
            let relativeUrl = raw.image.split(":")[2].split("/")
            relativeUrl.splice(0, 1)
            relativeUrl = relativeUrl.join("/")
            this.fileResult = "https://ktp.ocr.dev.inergi.id/api-plat/" + relativeUrl
            this.nVehicles = raw.n_vehicle
            this.results = raw.data.map(item => {
              let arr = []
              for(const [key, value] of Object.entries(item)){
                arr.push({ label: key, value: value })
              }
              return arr
            })
          } else {
            this.errorLabel = raw.message
            this.errorReload = false
            this.showErrorModal = true
          }
        }
        else {
          this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = false
          this.showErrorModal = true
          return
        }
      })
      .catch(error => {
        // if(error.response) this.errorLabel = error.response.data.reason
        if(error.response){
          if(error.response.status == "401"){
            this.errorLabel = "API Key tidak valid atau sudah tidak berlaku. Mohon menghubungi tim untuk kode akses baru."
            this.$cookies.remove("api-key-plat")
            delete this.$axios.defaults.headers.post['API-Key']
          }
          else{
            if(error.response.data && error.response.data.reason) this.errorLabel = error.response.data.reason
            else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          }
        }
        else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  },
  async mounted() {
    // this.$axios.defaults.headers.post['Content-Type'] = 'application/json';
    // this.$axios.post(processUrl, data, { headers: {"Content-Type": "multipart/form-data"} }).then((response) => {
    let res = ""
    if(this.$cookies.get("api-key-plat")){
      res = this.$cookies.get("api-key-plat")
      this.$axios.defaults.headers.post['API-Key'] = res
      this.$axios.defaults.headers.get['API-Key'] = res
      this.verified = true
    }
    else{
      while(!res) res = window.prompt("Please enter your access key.", "")
      while(!this.verified){
        // await this.$axios.post("http://10.10.131.108:9000/auth/validate-key", null, { headers: {"API-Key": res} }).then(_ => {
        await this.$axios.post("https://validation.demo.inergi.id/api/auth/validate-key", null, { headers: {"API-Key": res} }).then(_ => {
          this.$cookies.set("api-key-plat", res)
          this.$axios.defaults.headers.post['API-Key'] = res
          this.$axios.defaults.headers.get['API-Key'] = res
          this.verified = true
        })
        .catch(error => {
          if(error.response){
            if(error.response.status == "401"){
              res = ""
              while(!res) res = window.prompt("Key validation failed. Please enter your access key.", "")
            }
            else{
              res = ""
              while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
            }
          }
          else{
            res = ""
            while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
          }
        })
      }
    }
  },
}
</script>